import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';
import { installEdgeTrim } from './lib/trim-input';
import { installSelectedRows } from './lib/row-select';
import './style.css';

const assetReloadKey = 'file-cloud-asset-reload';
let reloadingForAssets = false;

// 发布后旧的分包地址会失效。静态资源回落成 HTML 时，刷新一次拿到新的入口。
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (reloadingForAssets) return;
  try {
    if (sessionStorage.getItem(assetReloadKey) === '1') return;
    sessionStorage.setItem(assetReloadKey, '1');
  } catch {
    return;
  }
  reloadingForAssets = true;
  window.location.reload();
});

const app = createApp(App);
const pinia = createPinia();
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

app.use(pinia);
app.use(VueQueryPlugin, { queryClient });

const auth = useAuthStore(pinia);
await auth.bootstrap();
// 路由安装时会立刻按当前地址导航。必须等刷新令牌恢复完再安装，否则守卫会把已登录用户送回登录页。
app.use(router);
await router.isReady();
installEdgeTrim();
app.mount('#app');
installSelectedRows();
if (!reloadingForAssets) {
  try {
    sessionStorage.removeItem(assetReloadKey);
  } catch {
    // 隐私模式可能禁用 sessionStorage，忽略即可。
  }
}
